<template>
<div class="p-section ctt-cnt aos-init aos-animate" data-aos="fade-up" data-aos-duration="1800">
        <p class="p-category-title">お問い合わせ</p>
        <h1 class="p-page-title">CONTACT</h1>
        <p class="u-center">
        弊社にご関心をお持ちいただきまして、ありがとうございます。<br>
        お問い合わせ内容に合わせて、以下の項目より窓口をお選び下さい。<br>
        なお、迅速な回答を心がけておりますが、お問い合わせ内容によっては、回答にお時間がかかる場合があります。<br>
        あらかじめご了承下さい。
        </p>
        <form action="" method="post" id="form" name="myform" novalidate="novalidate">
            <div class="tbl" align="center">
                <hr style="width: 65%">
                <div v-for="(category, index) in categories" v-bind:key="index">
                    <div class="tbl-col" style="width: 35%;text-align: center;cursor:pointer;display: flex;position: relative;" v-on:click="moveCategorySelect2(index)">
                        <p>{{ category }}</p><i style="position: absolute; right: -10px">></i>
                    </div>
                    <hr style="width: 65%">
                </div>
            </div>
        </form>
  </div>
</template>
<script>
export default {
  data () {
    return {
      categories: [
        'サービスに関するお問い合わせ',
        'ビジネスパートナーに関するお問い合わせ',
        '貴社商品・サービスのご提案',
        '上記以外のお問い合わせ'
      ]
    }
  },
  methods: {
    moveCategorySelect2: async function (index) {
      console.log('')
      window.location = '/' + process.env.URL_PREFIX + '#/category2/' + index
    }
  },
  mounted: function () {
    this.contactIsFinish = false
  }
}
</script>
<style scoped>
a {
color: 0000;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactTop.vue